import { sleep } from '@web3/utils';
import { isBrowser } from '../../../utils/trick';
import { WalletHub } from '../../core/WalletHub';
import { debugLog } from '../../../utils/common';

export interface EIP6963AnnounceProviderEvent extends CustomEvent {
  type: 'eip6963:announceProvider';
  detail: {
    info: {
      uuid: string;
      name: string;
      icon: string;
      rdns: string;
    };
    provider: any;
  };
}

export const get6963Wallets = (callback: (evt: EIP6963AnnounceProviderEvent) => void, delay = 1e3) => {
  if (!isBrowser) {
    return;
  }
  const list = new Set<string>();
  window.addEventListener('eip6963:announceProvider', (evt) => {
    debugLog('eip6963:announceProvider', evt);
    const event = evt as EIP6963AnnounceProviderEvent;
    if (list.has(event.detail.info.uuid)) {
      return;
    }
    // console.log(event.detail.info);
    list.add(event.detail.info.uuid);
    callback(evt as EIP6963AnnounceProviderEvent);
  });
  setTimeout(() => {
    debugLog('dispatching', 'eip6963:requestProvider');
    window.dispatchEvent(new Event('eip6963:requestProvider'));
  }, delay);
};

export const harvestWalletHub = <T = EIP6963AnnounceProviderEvent, Data = WalletHub>(
  harvestTime: number,
  {
    timeoutItemCallback,
    infoHandler,
    infoFilter,
  }: {
    timeoutItemCallback?: (evt: Data) => void;
    infoHandler?: (info: T) => Data;
    infoFilter?: (info: T) => boolean;
  } = {},
) => {
  const infos: Data[] = [];

  let resolvedFlag = false;
  const callback = (info: T) => {
    if (infoFilter && !infoFilter(info)) {
      return;
    }
    const res = infoHandler ? infoHandler(info) : (info as unknown as Data);
    // 超时就调用callback
    if (resolvedFlag) {
      timeoutItemCallback?.(res);
    } else {
      infos.push(res);
    }
  };
  return [
    callback,
    sleep(harvestTime).then(() => {
      resolvedFlag = true;
      return infos;
    }),
  ] as const;
};
